import { CheckCircle2 } from "lucide-react";

export default function PaySuccess() {
  return (
    <div className="min-h-screen brand-glow flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <CheckCircle2 className="mx-auto h-14 w-14 text-primary mb-4" />
        <h1 className="text-2xl font-bold">Payment received</h1>
        <p className="mt-3 text-muted-foreground">
          Thank you! Your payment was successful and a receipt has been emailed to you.
          If your plan includes a monthly fee, it will be charged automatically each month.
        </p>
        <p className="mt-8 text-sm text-muted-foreground">
          Averoan Technologies Inc. · <a className="text-primary" href="mailto:info@averoan.com">info@averoan.com</a>
        </p>
      </div>
    </div>
  );
}
